import React from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as NoSearchLogo } from '../../assets/images/svg/no-search3.svg'
import { makeStyles } from '@material-ui/styles'
import {
  Grid,
  Typography
} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  logo: {
    height: '60%',
    opacity: 0.5,
  },
  text: {
    textAlign: 'center',
    marginBottom: 10,
  },
}))

const EmptyList = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Grid className={classes.root}>
      <Typography className={classes.text}>
        {t('search.noResults')}
      </Typography>
      <NoSearchLogo className={classes.logo} />
    </Grid>
  )
}

export default EmptyList
